import ShiftPage from 'pages/shift/page'

export const shiftsRoutes = [{ path: '/shift', element: <ShiftPage /> }]
